import type { LucideIcon } from 'lucide-react';
import {
  Award,
  Heart,
  LifeBuoy,
  RotateCcw,
  Ship,
  ThumbsUp,
} from 'lucide-react';

export interface PdpDesktopPromiseBadge {
  id: string;
  title: string;
  href?: string;
  Icon: LucideIcon;
}

export const PDP_DESKTOP_PROMISE_BADGES: PdpDesktopPromiseBadge[] = [
  {
    id: 'returnable',
    title: '30 DAY RETURNABLE',
    href: '/shipping-return.html#30-day-return',
    Icon: RotateCcw,
  },
  {
    id: 'exchange',
    title: 'LIFETIME EXCHANGE & BUY-BACK POLICY',
    href: '/shipping-return.html#lifetime-exchange',
    Icon: LifeBuoy,
  },
  {
    id: 'certified',
    title: 'CERTIFIED JEWELLERY',
    href: '/certifications.html',
    Icon: Award,
  },
  {
    id: 'refund',
    title: '100% REFUND',
    href: '/shipping-return.html#30-day-return',
    Icon: ThumbsUp,
  },
  {
    id: 'shipping',
    title: 'FREE SHIPPING',
    href: '/shipping-return.html',
    Icon: Ship,
  },
  {
    id: 'returns',
    title: 'FREE RETURNS',
    href: '/shipping-return.html#30-day-return',
    Icon: Heart,
  },
];
